export default __webpack_public_path__ + "static/media/soy_fibromialgia_en_positivo.b72ec009.png";